import * as pay from "./pay";

export const kcp = {
    ...pay,
}
